import React from "react"

interface CloseButtonProps {
  /**
  * Unique identifier for the button.
  */
  id: string

  /**
   * Function to be called when the button is clicked.
   */
  onClick: () => void

  /**
   * Additional CSS classes for custom styling.
   * @default ""
   */
  className?: string
}

/**
 * @component CloseButton
 * @description A reusable close button component with an "X" icon.
 *
 * @param {CloseButtonProps} props - Component props.
 * @param {() => void} props.onClick - Function to execute when the button is clicked.
 * @param {string} [props.className] - Optional additional CSS classes for customization.
 *
 * @returns {JSX.Element} A circular close button with an "X" icon.
 */
const CloseButton: React.FC<CloseButtonProps> = ({
  id,
  onClick,
  className = "",
}) => {
  return (
    <button
      data-automation-id={id}
      id={id}
      onClick={onClick}
      className={`p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-200 ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-gray-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  )
}

export default CloseButton